<template>
  <div>
    <a-spin :spinning="loading">
      <div>
        <div class="row mb-2">
          <div class="col-12 col-md-12 text-right align-self-end">
            <!-- redeclare button -->
            <a href="javascript:;" v-if="rolesetting.canundeclare" :class="[`${parseInt(parseInt(this.status)) === 3 ? 'btn-success' : 'disabled btn-dark'}`,'btn btn-sm btn-with-addon mr-2']"
              @click="resetExam"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${parseInt(this.status) === 3 ? 'fe-stop-circle' : 'fe-play-circle'}`]" />
              </span>
              Reset
            </a>
            <!-- declare button -->
            <a href="javascript:;" v-if="rolesetting.candeclare" :class="[`${parseInt(this.status) === 3 ? 'disabled btn-dark' : 'btn-success'}`,'btn btn-sm btn-with-addon mr-2']"
              @click="declareExam"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${parseInt(this.status) === 3 ? 'fe-stop-circle' : 'fe-play-circle'}`]" />
              </span>
              {{ parseInt(this.status) === 3 ? 'Declared': 'Declare'}}
            </a>
          </div>
        </div>
        <a-divider></a-divider>
      </div>
      <div v-if="resultData.length !== 0 && parseInt(this.status) === 3" style="margin-top:10px">
        <!-- Exam Details -->
        <div class="row mb-2">
          <div class="col-12 col-md-12">
            <table class="table table-borderless table-sm mb-0">
              <tbody>
                <!-- 1st row -->
                <tr>
                  <td>
                    Exam: <b>{{ this.resultData[0].name }}</b>
                  </td>
                  <td>
                    Class: <b>{{ getClassName(this.resultData) }}</b>
                  </td>
                  <td>
                    Section: <b>{{ getSectionName(this.resultData) }}</b>
                  </td>
                </tr>
                <!-- 2nd row -->
                <tr>
                  <td>
                    Total applied: <b>{{ this.resultData[0].totalApplied === null ? 'NA' : this.resultData[0].totalApplied }}</b>
                  </td>
                  <td>
                    Student appeared: <b>{{ this.resultData[0].noOfAppeared === null ? 'NA' : this.resultData[0].noOfAppeared }}</b>
                  </td>
                  <td>
                    Student absent: <b>{{ getAbsent(this.resultData[0]) }}</b>
                  </td>
                </tr>
                <!-- 3rd row -->
                <tr>
                  <td>
                    No of pass: <b>{{ this.resultData[0].noOfPass === null ? 'NA' :  this.resultData[0].noOfPass}}</b>
                  </td>
                  <td>
                    No of fails: <b>{{ this.resultData[0].noOffail === null ? 'NA' : this.resultData[0].noOffail }}</b>
                  </td>
                  <td>
                    Pass percentage:
                    <b>{{ this.resultData[0].passPercent === null ? 'NA' :  this.resultData[0].passPercent }}%</b>
                  </td>
                </tr>
                <!-- 4th row -->
                <tr>
                  <td>
                    Exam date: <b>{{ this.resultData[0].examDate }}</b>
                  </td>
                  <td>Declared on: <b>{{ this.resultData[0].declaredDate === null ? 'NA' : this.resultData[0].declaredDate }}</b></td>
                </tr>
              </tbody>
            </table>
            <hr />
          </div>
        </div>
        <div class="row mb-2" v-if="rolesetting.resultviewable">
          <div class="col-12 text-right col-md-12">
            <a-input-search
              v-model="search"
              placeholder="Search by Name or Roll-No"
              style="width: 35.3%"
              size="large"
              @search="searchStudents"
              @change="searchStudents"
            />
            <a-tooltip placement="topLeft" title="Export result">
              <a-button
                type="primary"
                @click="bulkResultExport"
                style="margin-left: 10px; height:37px"
              >
                <a-icon type="export" />
                Bulk export
              </a-button>
            </a-tooltip>
          </div>
        </div>
        <div class="mt-3" v-if="rolesetting.resultviewable">
          <div class="card">
            <div class="card-body">
              <!-- <display-student-exam-report :examData="classSectionExamData"/> -->
              <DisplayStudentExamReport :data="this.studentResults" />
            </div>
          </div>
          <div class="text-right">
            <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="this.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
            </a-pagination>
          </div>
        </div>
        <div class="row justify-content-center" v-else>
          <p class="error">
            You don't have permission to use this feature.
          </p>
        </div>
      </div>
      <div v-else>
        <!-- qwe{{this.currentExamDetails}} -->
        <div class="row mb-2">
          <div class="col-12 col-md-12">
            <table class="table table-borderless table-sm mb-0">
              <tbody>
                <!-- 1st row -->
                <tr>
                  <td>
                    Exam: <b>{{ this.currentExamDetails.name }}</b>
                  </td>
                  <td>
                    Class: <b>{{ this.currentExamDetails.class.name }}</b>
                  </td>
                  <td>
                    Section: <b>{{ getSectionData(this.currentExamDetails) }}</b>
                  </td>
                </tr>
                <!-- 2nd row -->
                <tr>
                  <td>
                    Total applied: <b>NA</b>
                  </td>
                  <td>
                    Student appeared: <b>NA</b>
                  </td>
                  <td>
                    Student absent: <b>NA</b>
                  </td>
                </tr>
                <!-- 3rd row -->
                <tr>
                  <td>
                    No of pass: <b>NA</b>
                  </td>
                  <td>
                    No of fails: <b>NA</b>
                  </td>
                  <td>
                    Pass percentage:
                    <b>NA%</b>
                  </td>
                </tr>
                <!-- 4th row -->
                <tr>
                  <td>
                    Exam date: <b>{{ this.currentExamDetails.date }}</b>
                  </td>
                  <td>Declared on: <b>NA</b></td>
                </tr>
              </tbody>
            </table>
            <hr />
          </div>
        </div>
        <NoData text="Exam is not yet declare!" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
// import { omit, find } from 'lodash'

// import ClassExamMarksForm from '@/components/bosemexam/manage/Form/index'
import DisplayStudentExamReport from '@/components/online-exam/result/Display/index'

import NoData from '@/components/layout/NoData/index'

export default {
  name: 'DisplayClassSectionExam',
  components: {
    // ClassExamMarksForm,
    DisplayStudentExamReport,
    NoData,
    // BulkUploadStudentMark,
  },
  mounted: function() {
    this.getCurrentOnlineExamDetails(this.examId)
    this.getExamResult(this.examId)
  },
  props: ['status', 'rolesetting'],
  computed: {
    examId: function() {
      return this.$route.params.examId
    },
  },
  watch: {
    studentResults: function(val) {
      return val
    },
    currentExamDetails: function(val) {
      return val
    },
    status: function(val) {
      return parseInt(val)
    },
  },
  data: function() {
    return {
      loading: false,
      classSectionExamData: null,
      activeKey: ['1'],
      declared_status: '',
      declare_status: '',
      resultData: [],
      search: null,
      stat: null,
      studentResults: [],
      current: 1,
      pageSize: 10,
      total: null,
      name: [],
      currentExamDetails: [],
    }
  },
  methods: {
    // api.neoskool.xyz/api/online-exam/all?limit=30&page=1
    moment,
    bulkResultExport() {
      this.loading = true
      this.$http
        .get(`/api/online-exam/result/export/${this.examId}`, {
          headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
          },
          responseType: 'arraybuffer',
        })
        .then(response => {
          let blob = new Blob([response.data], {
            type: 'application/json',
          })
          this.$notification['info']({
            message: 'Exam result export started!',
            description: `Exam result export has started! You will be notified once it is completed!`,
          })

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Exam-result.xlsx'
          link.click()
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    resetExam() {
      this.$http
        .post('/api/online-exam/reset/' + this.examId)
        .then(({ data }) => {
          this.status = parseInt(data.status)
          this.getExamResult(this.examId)
          this.loading = false
          this.$notification['success']({
            message: 'Successfully reset',
            description: 'Exam successfully reset!',
          })
          // this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    declareExam() {
      this.loading = true
      this.$http
        .post('/api/online-exam/declare/' + this.examId)
        .then(({ data }) => {
          this.status = parseInt(data.status)
          this.getExamResult(this.examId)
          this.loading = false
          this.$notification['success']({
            message: 'Successfully declared',
            description: 'Exam successfully declared!',
          })
          // this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    getClassName(resultData) {
      if (resultData.length !== 0) {
        return resultData[0].studentsResults[0].class
      }
    },
    getSectionName(resultData) {
      if (resultData.length !== 0) {
        if (resultData[0].studentsResults[0].section !== null) {
          return resultData[0].studentsResults[0].section
        } else {
          return 'All'
        }
      }
    },
    getAbsent(absentDetails) {
      if (absentDetails.totalApplied !== null) {
        if (absentDetails.noOfAppeared === null) {
          return absentDetails.totalApplied
        } else {
          return parseInt(absentDetails.totalApplied) - parseInt(absentDetails.noOfAppeared)
        }
      } else {
        return 'NA'
      }
    },
    // getDeclareDate(declareData) {
    //   if (declareData.declareDate !== null || declareData.declareDate !== undefined) {
    //     return declareData.declareDate
    //   } else {
    //     return 'NA'
    //   }
    // },
    getSectionData (sectionDataPass) {
      if (sectionDataPass.section === null) {
        return 'All'
      } else {
        return sectionDataPass.section.name
      }
    },
    searchStudents: function(e) {
      this.search = e.target.value
      this.getSearchData(this.search)
    },
    getSearchData: function(inputData) {
      var foundByRollno = this.resultData[0].studentsResults.filter(obj =>
        obj.rollNo.startsWith(inputData)
      )
      if (foundByRollno.length === 0) {
        var foundName = this.resultData[0].studentsResults.filter(obj =>
          obj.firstName.startsWith(inputData)
        )
        if (foundName.length === 0) {
          this.studentResults = []
        } else {
          this.studentResults = foundName
        }
        if (foundName.length === 0 && foundByRollno.length === 0) {
          this.studentResults = []
        }
      } else {
        this.studentResults = foundByRollno
      }
    },
    getCurrentOnlineExamDetails: function(id) {
      // if (parseInt(this.status) === 3) {
      this.loading = true
      this.$http
        .get(`/api/online-exam/${id}`)
        .then(({ data }) => {
          this.currentExamDetails = data.data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
      // }
    },
    getExamResult(id) {
      if (parseInt(parseInt(this.status)) === 3) {
        this.loading = true
        this.$http
          .get(`/api/online-exam/result/${id}`)
          .then(({ data }) => {
            this.resultData = data.data
            this.studentResults = this.resultData[0].studentsResults
            this.total = this.studentResults.length
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$neoNotify.error(error)
          })
      }
    },
    // pagination related function........................................
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getExamResult()
    },
    onChange(current) {
      this.current = current
      this.getExamResult()
    },
  },
}
</script>
